import "@/components/CustomLoader/customLoader.scss";
import React from "react";

type CustomLoaderProps = {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  className?: string;
};

const CustomLoader: React.FC<CustomLoaderProps> = ({
  size = "md",
  className,
}) => {
  return (
    <div
      className={`custom_loader ${size}${className ? " " + className : ""}`}
    ></div>
  );
};

export default CustomLoader;
